import { StatsigProvider as Provider } from 'statsig-react'
import { useDispatch, useSelector } from 'react-redux'
import { PropsWithChildren } from 'react'

import { getDesignerVersion } from '../../components/Home/LinkFeedYouPlatformService'
import { useUserInfo } from '../../store/user'
import { actions as featureSliceActions } from '../../store/features/featuresSlice'
import { getFeatureAvailabilities, getStatsigGates } from './utils'
import { areFeatureValuesReadySelector } from '../../store/features/selectors'

export const StatsigProvider = ({ children }: PropsWithChildren<{}>) => {
  const user = useUserInfo()
  const dispatch = useDispatch()
  const areValuesReady = useSelector(areFeatureValuesReadySelector)

  return (
    <Provider
      sdkKey="client-sToFoJobdfO3eACXM99WRnEdlmELCECGmrx8aOAp5QR"
      // We will leverage persist, and prevent rendering manually when not ready
      waitForInitialization={false}
      user={{
        userID: user.email,
        email: user.email,
        appVersion: getDesignerVersion().replace('?', ''),
        custom: { instance: window.location.hostname }
      }}
      options={{
        // @ts-ignore
        environment: { tier: window.ENVIRONMENT || import.meta.env.MODE || 'production' },
        initCompletionCallback: (_, success) => {
          dispatch(
            featureSliceActions.setFeatureValues({ set: 'statsig', values: getStatsigGates() })
          )
          dispatch(featureSliceActions.setAvailabilities(getFeatureAvailabilities()))
          dispatch(featureSliceActions.markStatsigAsReady({ didStatsigInitFail: !success }))
        }
      }}
    >
      {areValuesReady && children}
    </Provider>
  )
}
